// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"RoomFacilitiesOverlayLayout-mobile__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/RoomFacilitiesOverlayLayout/RoomFacilitiesOverlayLayout.mobile.scss
 ** module id = 959
 ** module chunks = 1
 **/